export default __webpack_public_path__ + "static/media/i-link-green.8e766260.svg";